<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12">
						<div class="content margin-bottom-30">
							<div class="content-header">
								<h2>
									Sources ({{ tableData.length }})
								</h2>
							</div>
							<div class="content-body">
								<el-table :data="tableData" :default-sort="{ prop: 'source', order: 'ascending' }" style="width: 100%">
									<el-table-column label="Source" prop="name"></el-table-column>
									<el-table-column align="right" width="150">
										<template slot-scope="scope">
											<el-button @click="handleEdit(scope.row.id)" size="mini" type="primary" plain circle icon="el-icon-edit"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'
import { mapState } from 'vuex'

export default {
	name: 'Sources',
	metaInfo () {
		return {
			title: 'Sources',
		}
	},
	data () {
        return {
			loading: true,
			tableData: []
        }
    },
	computed: {
        ...mapState(['user'])
	},
	mounted () {
		if (parseInt(this.user.role) !== 1) {
			this.$router.push('/analytics')
		} else {
			this.loadData()
		}
	},
	methods: {
		loadData () {
			this.loading = true
			HTTP({
				method: 'GET',
				url: '/sources',
				crossdomain: true
			})
			.then(response => {
				this.tableData = response.data
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.message,
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleEdit (id) {
			this.$router.push('/sources/edit/' + id)
		}
	}
}
</script>
